import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './Login.css'; // Your NEW Login.css
import { setToken } from './Authutils';

// import { ReactComponent as EyeIcon } from '../../assets/icons/eye.svg';
// import { ReactComponent as EyeSlashIcon } from '../../assets/icons/eye-slash.svg';

const Login = () => {

  const baseUrl = process.env.REACT_APP_API_URL ; // Fallback URL
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [error, setError] = useState(''); // For general error message below title
  const [isLoggingIn, setIsLoggingIn] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoggingIn(true);

    try {
      const res = await axios.post(`${baseUrl}/admin/login`, { email, password }, { withCredentials: true });
      setToken(res.data.token);

      toast.success('Login successful! Redirecting...', {
        position: "top-center",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });

      const redirectTo = location.state?.from?.pathname || '/dash';
      setTimeout(() => {
        navigate(redirectTo);
      }, 2000);

    } catch (err) {
      const errorMessage = err.response?.data?.message || 'Invalid credentials or server error.';
      toast.error(errorMessage, {
        position: "top-center",
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      // You might want a more user-friendly generic message for the UI error spot
      setError('Login attempt failed. Please check your credentials.'); 
      console.error('Login error:', err.response ? err.response.data : err.message);
    } finally {
      setIsLoggingIn(false);
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="login-page-wrapper-stunning">
      <ToastContainer newestOnTop />
      <div className="login-container-stunning">
        {/* Optional Decorative Side Panel */}
        <div className="login-decoration-panel">
          <div className="decoration-content">
            {/* You can add a logo or an abstract graphic here */}
            <h2 style={{color:"white"}}>Admin Login</h2>
            <p>Unlock Your Potential.</p>
          </div>
        </div>

        <div className="login-form-panel">
          <div className="login-header-stunning">
            <h1 className="login-title-stunning">Welcome Back!</h1>
            <p className="login-subtitle-stunning">Enter your details to sign in.</p>
          </div>

          {error && <div className="error-message-stunning">{error}</div>}
          
          <form onSubmit={handleLogin} className="login-form-stunning">
            <div className="form-group-stunning">
              <label htmlFor="email">Email Address</label>
              <div className="input-icon-wrapper">
                {/* Optional: Email Icon */}
                {/* <UserIcon className="input-leading-icon" />  */}
                <input
                  type="email"
                  id="email"
                  placeholder="you@example.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
            </div>

            <div className="form-group-stunning">
              <label htmlFor="password">Password</label>
              <div className="password-input-wrapper-stunning input-icon-wrapper">
                 {/* Optional: Lock Icon */}
                {/* <LockIcon className="input-leading-icon" /> */}
                <input
                  type={showPassword ? "text" : "password"}
                  id="password"
                  placeholder="Enter your password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                <button
                  type="button"
                  onClick={togglePasswordVisibility}
                  className="toggle-password-visibility-stunning"
                  aria-label={showPassword ? "Hide password" : "Show password"}
                >
                  {showPassword ?"Hide " : "Show "}
                </button>
              </div>
            </div>
            
            <div className="form-options">
              {/* <label className="remember-me">
                <input type="checkbox" /> Remember me
              </label> */}
              {/* <a href="/forgot-password" className="forgot-password-stunning">Forgot password?</a> */}
            </div>

            <button 
              type="submit" 
              className="login-button-stunning" 
              disabled={isLoggingIn}
            >
              {isLoggingIn ? (
                <span className="spinner-stunning"></span>
              ) : (
                'Sign In'
              )}
            </button>
          </form>
          
          {/* <p className="signup-link-stunning">
            New here? <a href="/signup">Create an Account</a>
          </p> */}
        </div>
      </div>
    </div>
  );
};

export default Login;